const competitionCategory = [
	// {
	// 	text: '', key: 'text.all', value: null, type: [0, 1],
	// },
	{
		text: '', key: 'text.competitionCategory.free4all', value: 16, type: [1],
	},
	{
		text: '', key: 'text.competitionCategory.area_Championship', value: 2, type: [1],
	},
	{
		text: '', key: 'text.competitionCategory.district_Championship', value: 4, type: [1],
	},
	{
		text: '', key: 'text.competitionCategory.region_Championship', value: 6, type: [1],
	},
	{
		text: '', key: 'text.competitionCategory.national_Championship', value: 9, type: [1],
	},
	{
		text: '', key: 'text.competitionCategory.national_Runevent', value: 12, type: [1],
	},
	{
		text: '', key: 'text.competitionCategory.international_InvitationalWalking', value: 13, type: [1],
	},
	{
		text: '', key: 'text.competitionCategory.international_Runevent', value: 14, type: [1],
	},
	{
		text: '', key: 'text.competitionCategory.iAAF_Runevent', value: 15, type: [1],
	},
];

function getCompetitionCategory(_this, filter) {
	if (filter == null) return null;
	competitionCategory.forEach((x) => {
		x.text = _this.$t(x.key);
	});
	return competitionCategory.filter(x => x.type.includes(filter));
}

export default getCompetitionCategory;
